export default __webpack_public_path__ + "static/media/zoko.5a58499e.svg";